import { buildWorkflowTimeline } from '../streaming/buildWorkflowTimeline.js'
import {
  DESIGN_DNA_COMPLETE_PLAN_MARKDOWN,
  DESIGN_DNA_OBJECTIVE_MARKDOWN,
  DESIGN_DNA_OPENING_CALLOUT,
  DESIGN_DNA_PROCEED_CTA_MARKDOWN,
} from './designDnaDemoContent.part01.js'
import {
  DESIGN_DNA_REFERENCE_TABLE,
  DESIGN_DNA_SIGNALS_TABLE,
  DESIGN_DNA_TOKENS_YAML,
} from './designDnaDemoContent.part02.js'
import {
  DESIGN_DNA_MUI_MAPPING_TABLE,
  DESIGN_DNA_WRAP_UP_CALLOUT,
} from './designDnaDemoContent.part03.js'
import { DESIGN_DNA_AI_LOG_STEPS } from './designDnaDemoContent.part05.js'
import { DESIGN_DNA_FIGMA_APP_BLOCK } from './designDnaDemoContent.part06.js'

export function buildDesignDnaPlanBlocks(dnaArtifactId, opts = {}) {
  const streaming = opts.streaming ?? false
  const dnaLogBlock = streaming
    ? {
        type: 'aiResponseLog',
        status: 'ok',
        showLogStatus: false,
        stepTemplates: DESIGN_DNA_AI_LOG_STEPS,
      }
    : {
        type: 'aiResponseLog',
        status: 'ok',
        showLogStatus: false,
        steps: buildWorkflowTimeline(DESIGN_DNA_AI_LOG_STEPS),
      }

  return [
    { type: 'callout', style: 'info', content: DESIGN_DNA_OPENING_CALLOUT },
    { type: 'heading', level: 2, content: 'Complete Execution Plan' },
    { type: 'markdown', content: DESIGN_DNA_COMPLETE_PLAN_MARKDOWN },
    { type: 'divider' },
    { type: 'heading', level: 2, content: 'Design DNA — Key Findings' },
    { type: 'markdown', variant: 'muted', content: DESIGN_DNA_OBJECTIVE_MARKDOWN },
    { type: 'heading', level: 3, content: 'Reference Mix — 13 Pins' },
    { type: 'table', data: DESIGN_DNA_REFERENCE_TABLE },
    { type: 'heading', level: 3, content: 'Recurring Visual Signals' },
    { type: 'table', data: DESIGN_DNA_SIGNALS_TABLE },
    { type: 'heading', level: 3, content: 'Extracted Token System' },
    { type: 'code', language: 'yaml', content: DESIGN_DNA_TOKENS_YAML },
    { type: 'heading', level: 3, content: 'MUI Transformation Map' },
    { type: 'table', data: DESIGN_DNA_MUI_MAPPING_TABLE },
    { type: 'heading', level: 3, content: 'Connected Design Tools' },
    DESIGN_DNA_FIGMA_APP_BLOCK,
    { type: 'heading', level: 3, content: 'Extraction Trace' },
    dnaLogBlock,
    {
      type: 'fileArtifact',
      fileName: 'AI Design DNA — Internal Processing Report.md',
      description: 'Markdown',
      artifactKind: 'doc',
      artifactId: dnaArtifactId,
    },
    { type: 'callout', style: 'success', content: DESIGN_DNA_WRAP_UP_CALLOUT },
    { type: 'markdown', content: DESIGN_DNA_PROCEED_CTA_MARKDOWN },
  ]
}

/**
 * Phase 2 — MUI showcase generation + HTML artifact (Figma question attached on message).
 * @param {string} htmlArtifactId
 * @param {{ streaming?: boolean }} [opts]
 * @returns {object[]}
 */
